import React, {useState} from "react"

import {FieldViewSize} from "../../../../../const"

export default function FieldTimeReported_InlineValueEmpty(props:any) {

    const size : FieldViewSize = _.get(props, 'size', FieldViewSize.DEFAULT)

    const [isHovered, setIsHovered] = useState(false)

    const onMouseEnter = () => {
        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }

    const className = Classes("ui5-field-editable", "size-"+size, props.className, {
        'is-hovered'    : isHovered || props.children
    })

    return (
        <React.Fragment>
            <div className={className} onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                <div className="ui5-txt-no-accent-default txt-truncate">
                    {/*{props.field.placeholder}*/}
                </div>
            </div>
            {props.children}
        </React.Fragment>
    )
}
